export enum OptionTypes {
    Radio = 'radio',
    Checkbox = 'checkbox'
}
